export enum OrderStatus {
  NEW = 'Новый',
  DONE = 'Выполнен',
  CANCELED = 'Отменен',
  SENT = 'Отправлен',
  ACCEPTED = 'Принят',
  WAITING = 'Ожидает получения',
  PAYMENT_RECEIVED = 'Оплата получена', 
}